import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=d1b3b4a2"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports